(() => {
  const replaceLogoHeading = () => {
    const heading = document.querySelector('h1.header__heading');
    if (!heading) return;

    const wrapper = document.createElement('div');
    wrapper.className = heading.className;
    while (heading.firstChild) wrapper.appendChild(heading.firstChild);
    heading.replaceWith(wrapper);
  };

  const init = () => {
    replaceLogoHeading();

    if (window.__ingenioHomeFinalBound) return;
    window.__ingenioHomeFinalBound = true;

    const emit = (name, detail) => {
      const payload = Object.assign({ event: name }, detail || {});
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      document.dispatchEvent(new CustomEvent(`ingenio:${name}`, { detail: payload }));
    };

    const fieldMap = {
      eventVariant: 'variant',
      eventCta: 'cta',
      eventDestination: 'destination',
      eventIntent: 'intent',
      eventCategory: 'category',
      eventPosition: 'position',
      eventProductId: 'product_id',
      eventSourceSection: 'source_section',
      eventPillar: 'pillar',
      eventCity: 'city'
    };

    document.addEventListener('click', (event) => {
      const target = event.target.closest('[data-home-event]');
      if (!target || target.dataset.homeTracked === 'true') return;

      target.dataset.homeTracked = 'true';
      window.setTimeout(() => delete target.dataset.homeTracked, 0);

      const fields = {};
      Object.entries(fieldMap).forEach(([dataKey, payloadKey]) => {
        if (target.dataset[dataKey] !== undefined) fields[payloadKey] = target.dataset[dataKey];
      });
      emit(target.dataset.homeEvent, fields);
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-home-newsletter], .ihf-club-form');
      if (!form) return;
      emit('home_newsletter_submit', {
        variant: form.dataset.variant || 'FINAL',
        result: 'attempt'
      });
    });
  };

  init();
  document.addEventListener('shopify:section:load', replaceLogoHeading);
})();
